import { IPartySchema } from '../validation/PartySchema';
import { DateTime } from 'luxon';
import { ePartyType } from '../../../ui-toolkit/enums/ePartyType';

// Add typing
const partyToEntityRequest = (value: IPartySchema): IPartySchema => {
  const result = { ...value };
  result.signatories = !!value.signatories
    ? value.signatories.map((t) => {
        const signatory = { ...t };
        signatory.address = t.address ? { ...t.address } : undefined;
        return signatory;
      })
    : [];
  result.address = value.address ? { ...value.address } : undefined;
  return result;
};
const partyToPersonRequest = (value: IPartySchema): IPartySchema => {
  const result = { ...value };
  result.address = value.address ? { ...value.address } : undefined;
  result.dateOfBirth = value.dateOfBirth ? DateTime.fromISO(value.dateOfBirth).toISODate() : undefined;
  return result;
};

export const transformPartyFromFormToService = (values: IPartySchema[]): IPartySchema[] =>
  values.map((t) => (t.type === ePartyType.entity ? partyToEntityRequest(t) : partyToPersonRequest(t)));
